var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSubscription(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 17.042,
    height: 21.002,
    viewBox: "0 0 17.042 21.002",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "subscription_1_",
    "data-name": "subscription (1)",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_159",
    "data-name": "Path 159",
    d: "M9.04,3.206h2.447l-.927.928A.615.615,0,1,0,11.431,5L13.4,3.027a.616.616,0,0,0-.014-.884L11.431.18a.615.615,0,1,0-.871.869l.924.926H9.014A8.531,8.531,0,0,0,1.642,14.744a.615.615,0,1,0,1.068-.612A7.3,7.3,0,0,1,9.04,3.206Zm0,0",
    transform: "translate(-0.501 0.001)",
    fill: "#67E1AE"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_160",
    "data-name": "Path 160",
    d: "M108.941,145.3a.615.615,0,1,0-1.067.612,7.3,7.3,0,0,1-6.313,10.927H99.1l.927-.928a.615.615,0,1,0-.871-.869l-1.974,1.977a.616.616,0,0,0,.015.884l1.959,1.962a.615.615,0,1,0,.871-.869l-.924-.926h2.47a8.53,8.53,0,0,0,7.372-12.769Zm0,0",
    transform: "translate(-93.04 -139.042)",
    fill: "#67E1AE"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_161",
    "data-name": "Path 161",
    d: "M150.076,153.461h2.461a.615.615,0,1,0,0-1.231h-1.231v-.615a.615.615,0,0,0-1.231,0v.615a1.846,1.846,0,1,0,0,3.692h1.23a.615.615,0,1,1,0,1.231h-2.461a.615.615,0,0,0,0,1.231h1.231V159a.615.615,0,1,0,1.231,0v-.615a1.846,1.846,0,0,0,0-3.692h-1.23a.615.615,0,1,1,0-1.231Zm0,0",
    transform: "translate(-142.17 -144.806)",
    fill: "#67E1AE"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSubscription);
export default __webpack_public_path__ + "static/media/subscription.027de72cb5a8e221845ee2477c018dd2.svg";
export { ForwardRef as ReactComponent };